import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Landing from "@/pages/Landing";
import TreeDesigns from "@/pages/TreeDesigns";
import About from "@/pages/About";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";
import { ContentProvider } from "@/context/ContentContext";

function App() {
  useEffect(() => {
    const remove = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    remove();
    const observer = new MutationObserver(remove);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <HelmetProvider>
      <div className="App grain">
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/tree-designs" element={<TreeDesigns />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
        </ContentProvider>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              border: "1px solid rgba(169, 132, 47, 0.45)",
              color: "#122A1D",
              borderRadius: 0,
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
